import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; // <-- Add this for Firestore
import { getAuth } from "firebase/auth";       // <-- Add this for Authentication
import { getStorage } from "firebase/storage"; // <-- Make sure this import is present


const firebaseConfig = {
    apiKey: "AIzaSyD1M0pq9596WD5nBxHXVRKqGMysc_OeTjA",
    authDomain: "thessmun.firebaseapp.com",
    projectId: "thessmun",
    storageBucket: "thessmun.firebasestorage.app",
    messagingSenderId: "1063148756007",
    appId: "1:1063148756007:web:1a74d329dc866c0f534202",
    measurementId: "G-8MDMRH8NWM"
  };
  
  // Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app); // <-- Initialize Firestore
const auth = getAuth(app);   // <-- Initialize Authentication
const storage = getStorage(app);

// Export the initialized app instance AND the service instances
export { app, db, auth, storage }; // <-- Export db and auth too